import { useContext, useEffect } from "react";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import Paragraph from "../../../elements/p/Paragraph";
import modalContext from "../../../../dataManager/context/modalContext";
import Icon from "../../../elements/icons/Icon";
import productsContext from "../../../../dataManager/context/productsContext";
import {
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaFacebook,
} from "react-icons/fa";
import {
  shareOnFacebook,
  shareOnLinkedIn,
  shareOnWhatsapp,
  shareOnTwitter,
} from "../../../../functions/social";

const ShareProduct = () => {
  //context section
  const { onClose, modalParams } = useContext(modalContext);
  const { getOneProduct } = useContext(productsContext);

  //get the product
  const product = getOneProduct(modalParams.productId);

  //format the url
  const url = `${window.location.origin}/produits/${modalParams.productId}`;

  return (
    <div className="w-full">
      <Paragraph>
        Faites prendre connaissance des produits avec le meilleur rapport
        qualité/prix à votre entourage
      </Paragraph>
      <div className="my-5 flex items-center space-x-2">
        <Icon
          size="small"
          onShareToNetwork={shareOnWhatsapp}
          linkOfArticleToShare={url}
        >
          <FaWhatsapp size={200} />
        </Icon>
        <Icon
          onShareToNetwork={shareOnTwitter}
          linkOfArticleToShare={url}
          articleName={product.getName}
          size="small"
        >
          <FaTwitter size={200} />
        </Icon>
        <Icon
          onShareToNetwork={shareOnFacebook}
          linkOfArticleToShare={url}
          size="small"
        >
          <FaFacebook size={200} />
        </Icon>
        <Icon
          onShareToNetwork={shareOnLinkedIn}
          linkOfArticleToShare={url}
          size="small"
        >
          <FaLinkedinIn size={200} />
        </Icon>
      </div>
      <div className="flex items-center justify-end space-x-2">
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>
    </div>
  );
};

export default ShareProduct;
